import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Container } from 'react-bootstrap';
import UserTables from './UsersData/UserTables';


const Users = () => (
  <div>
    <Breadcrumbs
      style={{ marginLeft: '20px', marginBottom: '15px' }}
      aria-label="breadcrumb"
    >
      <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
      <Typography sx={{ color: 'text.primary' }}>User Manager</Typography>
      <Typography sx={{ color: 'text.primary' }}>Users</Typography>
    </Breadcrumbs>
    <Container>
      <UserTables />
    </Container>
  </div>

  );

export default Users;
